import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import * as Interface from '../functions/interfaces'


// Initialize
const config = {
    apiKey: "AIzaSyCs9JZAypTRhBevuaJW-HXiurz8rJs8TjM",
    authDomain: "adomanygyujto-f2d06.firebaseapp.com",
    projectId: "adomanygyujto-f2d06",
    storageBucket: "adomanygyujto-f2d06.appspot.com",
    messagingSenderId: "3497164071",
    appId: "1:3497164071:web:572e2d3e8590c4f25efd02"
};
firebase.initializeApp(config)


// Authentication
firebase.auth().onAuthStateChanged(async function (u) {
    
    // Admins
    let admins = [
        '5XIoN8Zc4qg6UiT7yFdNoJ519pT2' /* zolo */,
        '9uUZJfkOVrPHCyEJv6TgBqTlvXC3' /* attila */, 
        'd6GdedO2SZa98J5yAf2fvPst8fL2' /* szabo */]
    

    // Auth fields
    Vue.set(user, 'id', u?.uid || '')
    Vue.set(user, 'email', u?.email || '')
    Vue.set(user, 'admin', admins.includes(u?.uid))
    if (u == null) return


    // Personal fields
    let doc;
    try { 
        doc = await firebase.firestore().collection('users').doc(user.id).get() 
    
        // Process
        if (doc == null) return
        if (doc?.exists == false) return
        const details = doc.data()
        Vue.set(user, 'first_name', details?.first_name)
        Vue.set(user, 'last_name', details?.last_name)
        Vue.set(user, 'address', details?.address)
        user
    }
    catch(error) { console.log('Load user eror: ', error) }
})


// User
let user: Interface.User = {
    id: '',
    email: '',
    admin: false,
    first_name: '',
    last_name: '',
    address: {
        country: '',
        zip: '',
        city: '',
        line: ''
    }
}
export { user }